module.exports = __webpack_public_path__ + "img/SentDate.a74f5ebb.svg";